import theme from '@/common/styles/mui-theme';

const financialsStyles = {
  pageHeader: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    p: 6,
  },
  wrapper: {
    height: 'calc(100% - 92px)',
    minHeight: 0,
    overflow: 'auto',
  },
  body: {
    px: 6,
    pb: 6,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: 4,
  },
  incompleteQuestionnaireBody: {
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    pb: 0,
  },
  incompleteQuestionnaireText: {
    color: theme.palette.text.secondary,
    fontSize: '18px',
    lineHeight: '26px',
    maxWidth: 560,
    textAlign: 'center',
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    minHeight: 0,
  },
  sectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  sectionTitle: {
    color: theme.palette.text.primary,
    fontWeight: 500,
    fontSize: '24px',
    lineHeight: '32px',
    letterSpacing: '0px',
  },
  sectionBody: {
    p: 6,
    flex: 1,
    minHeight: 0,
    border: '1px solid #D8E1E8',
    borderRadius: '16px',
    backgroundColor: '#FFFFFF',
    overflow: 'hidden',
  },
  subSection: {
    '&:not(:last-child)': {
      marginBottom: theme.spacing(6),
    },
  },
  dataGridWrap: {
    width: '100%',
  },
  primaryCell: {
    fontSize: '18px',
    lineHeight: '24px',
    fontWeight: 500,
  },
  secondaryCell: {
    fontSize: '18px',
    lineHeight: '24px',
    fontWeight: 400,
  },
  clickableRow: {
    cursor: 'pointer',
  },
};

export default financialsStyles;
